/* eslint-disable no-unused-vars */
import "./style.css";
import * as React from "react";
import { useNavigate, Link } from "react-router-dom";
import Axios from "axios";
import { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import List from "../list";
import TextField from "@mui/material/TextField";
import logo from "../../images/logo1.png";
import logoMobile from "../../images/logo.png";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import { Button, ThemeProvider, createTheme } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Badge from "@mui/material/Badge";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCartOutlined';
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import home from "../../images/icon/home.png";
import who from "../../images/icon/who.png";
import ReactGA from "react-ga";
import FacebookIcon2 from "../../images/icon/fb.png";
import InstagramIcon2 from "../../images/icon/insta.png";
import YouTubeIcon2 from '../../images/icon/youtube.png';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    minWidth: "15px",
    height: "15px",
    padding: "0",
    right: -3,
    top: -2,
    borderRadius: "50%",
    backgroundColor: "#283943",
    color: "#F0E7D8",
    fontWeight: 600,
    fontSize: "11px",
    lineHeight: "14px",

    // ⭐ VERSION MOBILE (max-width: 600px)
    [theme.breakpoints.down("sm")]: {
      minWidth: "13px",
      height: "13px",
      fontSize: "9px",
      lineHeight: "11px",
      right: -2,
      top: -1,
    },
  },
}));




const customTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1080,
      lg: 1280,
    },
  },
});

function Header({ cartCount }) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


const searchRef = useRef(null);
useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      searchRef.current &&
      !searchRef.current.contains(event.target)
    ) {
     setShowSuggestions(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  document.addEventListener("touchstart", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
    document.removeEventListener("touchstart", handleClickOutside);
  };
}, []);
  const [isOpen, setIsOpen] = useState(false);
  let navigate = useNavigate();
 const toggleMenu = () => {
  setIsOpen(prev => {
    const newState = !prev;

    if (newState) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }

    return newState;
  });
};


  useEffect(() => {
    const track_id = "G-T6622GHTPT";
    ReactGA.initialize(track_id);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  const cartItems = JSON.parse(localStorage.getItem("cart"));

  const cartContain = cartItems ? cartItems.length : 0;

  const [inputText, setInputText] = useState("");
const [showSuggestions, setShowSuggestions] = useState(false);
  const textFieldRef = useRef(null);

const inputHandler = (e) => {
  const value = e.target.value;

  setInputText(value);

  // ouvrir seulement si texte existe
  setShowSuggestions(value.trim().length > 0);
};

  const handleSearchClick = () => {
    performSearch();
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      performSearch();
    }
  };

  const performSearch = () => {
    if (inputText.trim().length > 0) {
      setShowSuggestions(false);
      navigate(`/search?query=${encodeURIComponent(inputText.trim())}`);
    }
  };
  // Fermer le menu si on clique/touche en dehors
useEffect(() => {
  const handleOutside = (event) => {
    const menu = document.getElementById("navMenu");

    if (isOpen && menu && !menu.contains(event.target)) {
      setIsOpen(false);
      document.body.classList.remove("menu-open");
    }
  };

  document.addEventListener("mousedown", handleOutside);
  document.addEventListener("touchstart", handleOutside);

  return () => {
    document.removeEventListener("mousedown", handleOutside);
    document.removeEventListener("touchstart", handleOutside);
  };
}, [isOpen]);

useEffect(() => {
  return () => {
    document.body.classList.remove("menu-open");
  };
}, []);

  const location = useLocation();

  useEffect(() => {
    const pageTitle = location.pathname.split("/").pop();
    if (pageTitle === "") {
      // eslint-disable-next-line no-useless-concat
      document.title = "Ebuy";
    } else {
      document.title = `${decodeURIComponent(pageTitle).replace(/%20/g, " ")}`;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);




  return (
    <ThemeProvider theme={customTheme}>
    <div className={`header ${isScrolled ? "scrolled" : ""}`} id="header">

     <div className={`navbarTop ${isScrolled ? "hideTop" : ""}`}>

        <p class="wave-text">
  <span>Bienvenue </span>
  <span>sur </span>
  <span>eBuy :</span>
  <span> Votre </span>
  <span>solution </span>
  <span>de </span>
  <span>shopping </span>
  <span>en </span>
  <span>un </span>
  <span>clic </span>
</p>

        </div>

      <div className={`navbar ${isScrolled ? "smallNav" : ""}`}>

          <div className="logoDiv">
            <Link to="/">
              <img src={logo} alt="logo" className="logo" />
               <img src={logoMobile} alt="logo" className="logoMobile" />
            </Link>
 <a href="tel:27890006" className="telMobile">
  <Button
    startIcon={<LocalPhoneIcon />}
    className="phoneButton"
  >
    27 890 006
  </Button>
</a>
            <IconButton
              sx={{
                display: {
                  lg: "none",
                  md: "none",
                  sm: "none",
                  xs: "inline-block",
                  zIndex: 990999999999999,
                },
              }}
              onClick={toggleMenu}
            >
              {!isOpen ? (
                <MenuIcon
                  id="openIcon"
                  fontSize="small"
                  color="warning"
                  sx={{
                    top: "0px",
                    right: "0px",
                  }}
                />
              ) : (
                <CloseIcon
                  id="closeIcon"
                  color="warning"
                  fontSize="medium"
                  sx={{
                    top: "25px",
                    right: "10px",

                    position: "fixed",
                  }}
                />
              )}
            </IconButton>
            <div id="navMenu" className={isOpen ? "linkMenu show" : "linkMenu"}>
              <ol>
                <div className="socialMediaIcon">
                  <h3>Suivez-nous :</h3>
                  <a
                    href="https://www.instagram.com/ebuy.tunisie"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={InstagramIcon2} alt="facebookIcon" />
                  </a>
                  <a
                    href="https://www.youtube.com/@EbuyTunisia"
                    target="_blank"
                    rel="noreferrer"
                  >
                  <img src={YouTubeIcon2} alt="facebookIcon" />
                  </a>
                  <a
                    href="https://www.facebook.com/profile.php?id=61556332296913"
                    target="_blank"
                    rel="noreferrer"
                  >
                  <img src={FacebookIcon2} alt="facebookIcon" />
                  </a>
                </div>
                <li>
                  <div className="iconContainer">
                    <a onClick={toggleMenu} className={`linkItems `} href="/">
                      <img src={home} alt="home" className="iconImg home" />
                      <span > Acceuil </span>
                    </a>
                  </div>
                </li>

                <li>
                  {icons.map((icon, index) => (
                    <div key={index} className="iconContainer">
                      <a
                        href={icon.lien}
                        target="_blank"
                        rel="noreferrer"
                        className="linkItems"
                      >
                        <img
                          src={require(`../../images/icon/${icon.name}.png`)}
                          alt={icon.name}
                          className="iconImg"
                        />

                        <span>{icon.name}</span>
                      </a>
                    </div>
                  ))}
                </li>
                <li>
                  <div className="iconContainer">
                    <a className={`linkItems `} href="/qui-sommes-nous">
                      <img src={who} alt="who" className="iconImg home" />
                      <span> Qui sommes-nous ? </span>
                    </a>
                  </div>
                </li>
              </ol>
            </div>
          </div>
          <div className="userDiv">
            <div className="callandsearch">
           <div className="searchListDiv" ref={searchRef}>
<TextField
  fullWidth
  placeholder="Rechercher un produit ..."
  variant="outlined"
  value={inputText}
  onChange={inputHandler}
  onKeyPress={handleKeyPress}
  inputRef={textFieldRef}
  InputProps={{
    startAdornment: (
      <SearchIcon
        sx={{
          marginRight: '8px',
          color: '#283943'
        }}
      />
    ),
  }}
/>


                 <div className={`searchList ${isScrolled ? "smallsearchList" : ""}`}>
               {showSuggestions && inputText.trim().length >= 2 && (
  <List input={inputText} />
)}
              </div>
            </div>
 <a href="tel:27890006" style={{marginTop:'5px'}} className="telPc">
  <Button
    startIcon={<LocalPhoneIcon />}
    sx={{
      color: "black",
      fontFamily: "Exo",
      fontWeight:'600',
      marginLeft: { xs: 0, sm: 0, md: "20px" },

      fontSize: {
        xs: "11px",
        sm: "12px",
        md: "14px"
      },

      padding: {
        xs: "4px 6px",
        sm: "3px 8px",
        md: "4px 10px"
      },

      /* 🔥 contrôle la taille de l'icône */
      "& .MuiSvgIcon-root": {
        fontSize: {
          xs: 'small',   // mobile
          sm: 14,   // tablette
          md: 18    // PC
        }
      }
    }}
  >
    27 890 006
  </Button>
</a>
           </div>
            <Link to="/panier" className="cartLink">
              <IconButton aria-label="cart" color="warning" title="Panier">
                <StyledBadge badgeContent={cartCount} sx={{fontSize:'2px'}} color="warning" showZero>

                  <ShoppingCartIcon className={`shopIcon ${isScrolled ? "shopIconSmall" : ""}`} />
                </StyledBadge>
              </IconButton>
             <span> panier</span>
            </Link>
          </div>
        </div>
      </div>
    <div className={`navbarBottom ${isScrolled ? "hideBottom" : ""}`}>

        <div className="navbarIcon">
          {icons.map((icon, index) => (
            <div key={index} className="iconContainer">
              <a href={icon.lien} target="_blank" rel="noreferrer">
                <img
                  src={require(`../../images/icon/${icon.name}.png`)}
                  alt={icon.name}
                  className="iconImg"
                />

                <span>{icon.name}</span>
              </a>
            </div>
          ))}
        </div>
      </div>
    </ThemeProvider>
  );
}

export default Header;
const icons = [
  { name: "électroménager & cuisine", lien: "/collections/electromenager-and-cuisine" },
  {
    name: "maison & déco",
    lien: "/collections/maison-and-deco",
  },
  { name: "beaute & sante", lien: "/collections/informatique-and-lifestyle/lifestyle/beaute-and-sante" },
  { name: "informatique", lien: "/collections/informatique-and-lifestyle/informatique" },
  { name: "accessoires", lien: "/collections/informatique-and-lifestyle/lifestyle/accessoires" },
  { name: "tout à -100", lien: "/collections/tout-a-100-dt" },
    { name: "bons plans", lien: "/bons-plans" },
  { name: "nos marques", lien: "/nos-marques" },

];
